<template>
  <div class="info">
    <lb-table
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @selection-change="onMultipleSelection"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    LbTable
  },
  props: {
    userId: Number
  },
  data () {
    return {
      name: 'cdd',
      list: [],
      columns: [
        { label: '提现时间', prop: 'createdTime', minWidth: '120' },
        { label: '提现类型', prop: 'typeLabel', minWidth: '220' },
        { label: '提现方式', prop: 'payType', minWidth: '120' },
        {
          label: '提现账号', prop: 'account', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <div style="text-align:left">账号：{scope.row.account}</div>
                <div style="text-align:left">名称：{scope.row.name}</div>
              </div>
            )

          }
        },
        { label: '提现金额', prop: 'applyMoney', minWidth: '120' },
        { label: '手续费', prop: 'handlingFee', minWidth: '120' },
        { label: '实际到账', prop: 'receivedMoney', minWidth: '120' },
        {
          label: '状态', prop: 'applyStatusLabel', minWidth: '120', Algin: 'center',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.applyStatusLabel == '待审核') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background: #FF9226;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.applyStatusLabel}</div>
              </p>
            } else if (scope.row.applyStatusLabel == '已驳回') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background: #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.applyStatusLabel}</div>
              </p>
            } else if (scope.row.applyStatusLabel == '已到账') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.applyStatusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background:  #C0C0CC;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.applyStatusLabel}</div>
              </p>
            }
            return (
              <div> {vv}</div>

              // <p style="color:#303033;font-size:14px;">{scope.row.verifyStatusLabel}</p>
            )
          }
        }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' }
    }
  },
  created () {
    this.getWithdrawlPageList()
  },
  methods: {
    onMultipleSelection (e) { },
    handleSizeChange (e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getWithdrawlPageList()
    },
    handleCurrentChange (e) {
      this.page.pageNo = e;
      this.getWithdrawlPageList()
    },
    getWithdrawlPageList () {
      let data = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        userId: this.userId
      }
      this.axios.post('/users/getWithdrawlPageList', data)
        .then(res => {
          if (res.code == 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    }
  }
}
</script>
<style scoped lang="scss">
.info {
  padding-top: 20px;
  padding-bottom: 20px;
  /deep/ .el-table .el-table__header .el-table__cell{
    padding: 0;
  }
  /deep/ .el-table .el-table__row .el-table__cell{
    color: #303033;
    font-weight: 400;
  }
}

</style>

